import FormTitle from 'platform/forms-system/src/js/components/FormTitle';
import recordEvent from 'platform/monitoring/record-event';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { hrefWithBasename } from 'platform/forms-system/src/js/helpers';
import { useHeadingFocus } from 'platform/shared/health-apps';
import CaregiversPrivacyActStatement from '../components/IntroductionPage/CaregiversPrivacyActStatement';
import ProcessTimeline from '../components/IntroductionPage/ProcessTimeline';
import content from '../locales/en/content.json';

export const IntroductionPage = ({ route, router }) => {
  const startBtn = useMemo(() => {
    const nextPath = route.pageList[1].path;
    const href = hrefWithBasename(router, nextPath);
    const startForm = e => {
      e.preventDefault();
      recordEvent({ event: 'caregivers-10-10cg-start-form' });
      return router.push(nextPath);
    };
    return (
      <va-link-action
        href={href}
        text={content['button-start-app']}
        data-testid="form-start-link"
        onClick={startForm}
      />
    );
  }, [route.pageList, router]);

  useHeadingFocus();

  return (
    <div className="schemaform-intro">
      <FormTitle
        title={route.formConfig.title}
        subTitle={route.formConfig.subTitle}
      />
      <p className="va-introtext">{content['app-intro']}</p>

      {startBtn}

      <ProcessTimeline />

      {startBtn}

      <va-omb-info
        res-burden={15}
        omb-number="2900-0768"
        exp-date="01/31/2027"
        class="vads-u-margin-top--4"
      >
        <CaregiversPrivacyActStatement />
      </va-omb-info>
    </div>
  );
};

IntroductionPage.propTypes = {
  route: PropTypes.shape({
    formConfig: PropTypes.shape({
      subTitle: PropTypes.string,
      title: PropTypes.string,
    }),
    pageList: PropTypes.array,
  }),
  router: PropTypes.shape({
    push: PropTypes.func,
  }),
};

export default IntroductionPage;
